import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "image-operation"
};
import { Delete, View } from '@element-plus/icons-vue';
import { toRefs } from 'vue';
import { onMounted, ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'ItemCard',
  props: {
    detail: {
      type: Object,
      require: true
    }
  },
  emits: ['onBtnClick', 'onMjBtnClick'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const cardImageRef = ref(); // 卡片 image ref
    const emits = __emit; // emits
    /** 处理点击事件  */
    const handleButtonClick = async (type, detail) => {
      emits('onBtnClick', type, detail);
    };
    /** 监听详情 */
    const {
      detail
    } = toRefs(props);
    /** 初始化 */
    onMounted(async () => {
      if (!props.detail) {
        return;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createBlock(_component_el_card, {
        "body-class": "",
        class: "image-card"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
          class: "w-[150px] mb-2",
          truncated: ""
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(detail)?.prompt), 1)]),
          _: 1
        })]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
          class: "btn",
          text: "",
          icon: _unref(Delete),
          onClick: _cache[0] || (_cache[0] = $event => handleButtonClick('delete', _unref(detail)))
        }, null, 8, ["icon"]), _createVNode(_component_el_button, {
          class: "btn",
          text: "",
          icon: _unref(View),
          onClick: _cache[1] || (_cache[1] = $event => handleButtonClick('view', _unref(detail)))
        }, null, 8, ["icon"])])]), _createElementVNode("div", {
          class: "image-wrapper",
          ref_key: "cardImageRef",
          ref: cardImageRef
        }, [_createVNode(_component_el_text, {
          "line-clamp": "5"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(detail)?.generatedContent), 1)]),
          _: 1
        })], 512)]),
        _: 1
      });
    };
  }
});